import { DATA_Address } from '@api-new/common';
import { AddressFormValues } from '../forms/address.form';

export const addressFormToDataAddressAdapter = (formAddressData: AddressFormValues): DATA_Address => ({
  uprn: undefined,
  buildingName: formAddressData.buildingName || '',
  buildingNumber: formAddressData.buildingNumber || '',
  city: formAddressData.city || '',
  companyName: formAddressData.companyName || '',
  postcode: formAddressData.postcode || '',
  street: formAddressData.street || '',
  dependentStreet: '',
  subBuildingName: '',
});
